














// <Select
// v-model="item"
// placeholder="Текст заглушки"
// :items="items"
// />
// items = [{id: dataToServer, text:"dataToFront"}]
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "Select",
})
export default class Select extends Vue {
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  value!: string;
  @Prop({
    type: Boolean,
    default() {
      return;
    },
  })
  required!: boolean;
  @Prop({
    type: Array,
  })
  values!: object[];
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  placeholder!: string;

  // data
  private classes: any = {
    "lfs-pd-input-block-requred": this.required,
  };
  item: string = this.value;

  //   methods
  handleInput() {
    // let result = this.values.filer(item => item.value == this.item)
    this.$emit("input", this.item);
  }
}
